import PropTypes from 'prop-types';
import { InputSelectField } from '@tempmee/react';
import { useAccessibleName } from '../../hooks/useAccessibleName';

/**
 * `InputSelectField` with an accessible name (see `useAccessibleName` for why it goes through
 * the ref). For filter bars, `filters/SelectFilter` does the same with its own layout.
 */
export const LabelledSelectField = ({ ariaLabel, ...props }) => {
  const nameTrigger = useAccessibleName(ariaLabel);
  return <InputSelectField ref={nameTrigger} {...props} />;
};

LabelledSelectField.propTypes = {
  /** The trigger's accessible name, e.g. the visible label beside it. */
  ariaLabel: PropTypes.string.isRequired,
};
